import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Utils
import { getIsEmailValid } from 'utils/common';

import {
  BUTTON_CAPTION,
  COMMON_ERRORS,
} from 'constants/common';
import { DETALIZATION_MODAL_COMMON } from 'constants/detalization';

// Components
import { Text, Button, Input } from '@beef/ui-kit';
import { BackButton } from '../BackButton';

// Styles
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const EmailForm = ({
  isMobile,
  isFetching,
  isError,
  inputData,
  onGoBack,
  onSubmit,
  disabled,
}) => (
  <>
    <div className={cx('back-wrapper')}>
      <BackButton onClick={onGoBack} />
    </div>
    <Text size="size3-b">{DETALIZATION_MODAL_COMMON.MAIL_CAPTION}</Text>
    <div className={cx('info-text')}>
      <Text size="size5-r-l">{DETALIZATION_MODAL_COMMON.MAIL_INFO_MASSAGE}</Text>
    </div>
    <form className={cx('form')} onSubmit={onSubmit}>
      <div className={cx('input-wrapper')}>
        <Input
          label="E-mail"
          name="e-mail"
          type="email"
          placeholder="beeline@be.ru"
          {...inputData}
        />
      </div>
      <Button
        isLoading={isFetching}
        fullWidth={isMobile}
        size="m"
        type="submit"
        disabled={disabled}
      >
        {BUTTON_CAPTION.SAVE}
      </Button>
    </form>
    {isError && (
    <div className={cx('error')}>
      <Text size="size5-r-l">{COMMON_ERRORS.WENT_WRONG}</Text>
    </div>
    )}
  </>
);

EmailForm.propTypes = {
  isMobile: PropTypes.bool,
  email: PropTypes.string,
  isFetching: PropTypes.bool,
  isError: PropTypes.bool,
  inputData: PropTypes.string,
  onGoBack: PropTypes.func,
  onSubmit: PropTypes.func,
  isEmailConfirmed: PropTypes.bool,
  disabled: PropTypes.bool,
};
